import React from 'react'
import { Box } from "grommet"
import { JSONTree } from 'react-json-tree';
import { JsonInvert } from './theme'

// https://github.com/reduxjs/redux-devtools/tree/75322b15ee7ba03fddf10ac3399881e302848874/src/react/themes

export const treeTheme = {
    scheme: 'monokai',
    author: 'wimer hazenberg (http://www.monokai.nl)',
    base00: '#272822',
    base01: '#383830',
    base02: '#49483e',
    base03: '#75715e',
    base04: '#a59f85',
    base05: '#f8f8f2',
    base06: '#f5f4f1',
    base07: '#f9f8f5',
    base08: '#f92672',
    base09: '#fd971f',
    base0A: '#f4bf75',
    base0B: '#a6e22e',
    base0C: '#a1efe4',
    base0D: '#66d9ef',
    base0E: '#ae81ff',
    base0F: '#cc6633'
}

export const TTJsonTree = ({ data, standalone = false, expandAll = false, maxLevels = 100 }) => {

    let expandFirstLevel = (keyName, data, level) => level <= 1;
    if (expandAll === true) {
        expandFirstLevel = (keyName, data, level) => level <= maxLevels;
    }

    if (!standalone) {
        return (
            <Box flex={false} margin={{ left: "xsmall", right: "xsmall" }} fill="horizontal">
                <JSONTree data={data} theme={treeTheme} invertTheme={JsonInvert()} hideRoot={true} shouldExpandNodeInitially={expandFirstLevel} />
            </Box>
        )
    } else {
        return (
            <JSONTree data={data} theme={treeTheme} invertTheme={JsonInvert()} hideRoot={true} shouldExpandNodeInitially={expandFirstLevel} />
        )
    }
}

export default TTJsonTree